export default __webpack_public_path__ + "img/allergy-mustard.fc03c1be170d17aea3b82bd33579cdd2.svg";